module.exports = __webpack_public_path__ + "img/xdcj.5701499f.png";